module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-15.dd3ed92f.png";